import React from 'react';
import TecidoQuantidadeStepTemplate, {
  TecidoProps,
} from '../../../template/TecidoQuantidadeStepTemplate';
import { createBackHandler } from '../../../template/utils';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import AjusteDeGastoTecido from './AjusteDeGastoTecido';
import AjusteDeGastoTecidoFinalStep from './AjusteDeGastoTecidoFinalStep';

const AjusteDeGastoTecidoQuantidadeStep: TipoDivergenciaComponent<TecidoProps> = ({
  onSetStep,
  onBack,
  payload,
  onClose,
}) => {
  const backComponent = AjusteDeGastoTecido;
  const nextComponent = AjusteDeGastoTecidoFinalStep;

  const onBackHandler = createBackHandler(onBack, backComponent);
  return (
    <TecidoQuantidadeStepTemplate
      nextStepComponent={nextComponent as TipoDivergenciaComponent}
      onClose={onClose}
      onSetStep={onSetStep}
      onBack={onBackHandler}
      payload={payload}
    ></TecidoQuantidadeStepTemplate>
  );
};

export default AjusteDeGastoTecidoQuantidadeStep;
